import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import { Modal, Toast } from "react-bootstrap";
import useAuth from "../hooks/useAuth";
import Loader from "../hooks/loader";
import QRCode from "react-qr-code";
import { useCheckAllowance } from "../hooks/dataSender/Allowance";
import useApprove from "../hooks/dataSender/Approval";
import { useTransfer } from "../hooks/dataFetcher/transfer";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  CRASH_GAME_CONTRACT,
  CHAIN_TO_TOKEN_ADDRESSES,
  AQUA_SWAP_TX_STATUS,
  CHAIN_TO_TOKEN_MIN_AMOUNT,
} from "../utils/Enviroment";
import showToast from "../hooks/showToast";
import backendClient from "../utils/backendClient";
import axios from "axios";
import { useSocketEvents } from "../hooks/sokit2";
const CHAIN_IMAGES = {
  ARBITRUM: "/assets/playassets/arbitrum.svg",
  BASE: "/assets/playassets/base.svg",
  BSC: "/assets/playassets/bsc.svg",
  ETHEREUM: "/assets/playassets/eth.svg",
};
const TOKEN_IMAGES = {
  USDT: "/assets/playassets/usdtcircle.svg",
  USDC: "/assets/playassets/usdc.svg",
  ETH: "/assets/playassets/eth.svg",
  BNB: "/assets/playassets/bnb.svg",
};
const DepositModel = ({
  setShow5,
  show5,
  handleClose5,
  internalAccount,
  userBalanceExternal,
  ethExternalBalance,
  onTransactionUpdate,
  bnbPrice,
}) => {
  const tokenArry = [
    { simbal: "ETH", image: "/assets/playassets/eth.svg" },
    { simbal: "USDC", image: "/assets/playassets/usdc.svg" },
  ];
  const [selectedToken, setSelectedToken] = useState("USDC");
  const [selectedImage, setSelectedImage] = useState(
    "/assets/playassets/usdc.svg"
  );
  const [sokitHit, setSokitHit] = useState([]);
  const [copy, setCopy] = useState(false);
  const [show6, setShow6] = useState(false);
  const handleClose6 = () => {
    setShow6(false);
    window.location.reload();
  };
  const handleShow6 = () => setShow6(true);
  const transferFunds = useTransfer();
  const approvee = useApprove();
  const [depositeInput, setDepositeInput] = useState(null);
  const { checkAllowance } = useCheckAllowance();
  const [loading, setLoading] = useState(false);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [errorBool, setErrorBool] = useState(false);
  const [isUsdt, setIsUsdt] = useState(true);
  let { account } = useWeb3React();
  const [connected, setConnected] = useState(false);
  const [address, setAddress] = useState(false);
  const [depositeTokenAddress, setDepositeTokenAddress] = useState("");
  const [showWarning, setShowWarning] = useState(false);

  const handleCloseWarning = () => setShowWarning(false);
  const handleShowWarning = () => setShowWarning(true);
  //api func
  const depositAPI = async (hash) => {
    try {
      const tokenSymbol = isUsdt ? "USDT" : "BNB";
      const payload = {
        // address: account,
        amount: depositeInput,
        token: isUsdt ? "USDT" : "BNB",
        chain: "BSC", // replace with dynamic chain if needed
        txHash: hash,
        // timestamp: new Date().toISOString(),
      };
      if (tokenSymbol === "BNB" && bnbPrice && depositeInput) {
        // Calculate the USD value using the passed-in price
        const amountInUSD = parseFloat(depositeInput) * bnbPrice;
        // Add the new field to the payload
        payload.amountUSD = amountInUSD.toFixed(2);
      }
      await backendClient.post("/transactions/create-deposit", payload);
      // toast.success("Deposit recorded successfully");
    } catch (err) {
      console.error("Deposit API error:", err);
      toast.error("Deposit failed. Please try again.");
    }
  };
  const depositeTransection = async () => {
    setLoading(true);
    try {
      if (isUsdt) {
        const checkUserAllowance = await checkAllowance(
          account,
          CRASH_GAME_CONTRACT
        );

        let value = await transferFunds(internalAccount, depositeInput, isUsdt);
        if (value) {
          if (value?.transactionHash) {
            await depositAPI(value.transactionHash);
          }
          if (typeof onTransactionUpdate === "function") {
            await onTransactionUpdate();
          }
          setLoading(false);
          handleShow6();
          handleClose5();
        }
      } else {
        let value = await transferFunds(internalAccount, depositeInput, isUsdt);
        if (value) {
          if (value?.transactionHash) {
            await depositAPI(value.transactionHash);
          }
          if (typeof onTransactionUpdate === "function") {
            await onTransactionUpdate();
          }
          setLoading(false);
          handleShow6();
          handleClose5();
        }
      }
    } catch (err) {
      toast.error("deposit failed");
      setLoading(false);
      setLoaderText({
        heading: "",
        paragraph: "",
      });
    }
  };
  const depositeHander = (e) => {
    setDepositeInput(e.target.value);
    if (isUsdt) {
      if (+e.target.value > +userBalanceExternal) {
        setErrorMessage("Amount must be less than balance");
        setErrorBool(true);
      } else {
        setErrorMessage("");
        setErrorBool(false);
      }
    } else {
      if (+e.target.value > +ethExternalBalance) {
        setErrorMessage("Amount must be less than balance");
        setErrorBool(true);
      } else {
        setErrorMessage("");
        setErrorBool(false);
      }
    }
  };
  const CallCopy = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, [3000]);
  };
  const maxHandler = () => {
    if (isUsdt) {
      setDepositeInput(userBalanceExternal);
    } else if (ethExternalBalance > 0.000002) {
      setDepositeInput(ethExternalBalance - 0.000001);
    } else {
      setDepositeInput(0);
    }
    // {isUsdt ? (
    //   <>
    //     {Number(userBalanceExternal)?.toLocaleString(
    //       undefined,
    //       {
    //         minimumFractionDigits: 4,
    //         maximumFractionDigits: 4,
    //       }
    //     )}
    //   </>
    // ) : (
    //   <>
    //     {Number(ethExternalBalance)?.toLocaleString(undefined, {
    //       minimumFractionDigits: 5,
    //       maximumFractionDigits: 5,
    //     })}
  };

  const [selectedChain1, setSelectedChain1] = useState("BASE");
  const [selectedToken1, setSelectedToken1] = useState("USDC");
  const [selectedTokenAddress, setSelectedTokenAddress] = useState(
    CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC
  );

  // Call DepositeFunds on mount with default values
  useEffect(() => {
    if (internalAccount) {
      const defaultTokenAddress = CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC;
      DepositeFunds(defaultTokenAddress, "USDC");
    }
  }, [internalAccount]);

  const handleChainSelect1 = (chain1) => {
    setSelectedChain1(chain1);
    setSelectedTokenAddress(null);
    setDepositeTokenAddress("");
    setSelectedToken1(null); // reset token when chain changes
  };

  const handleTokenSelect1 = async (token1) => {
    const tokenAddress = CHAIN_TO_TOKEN_ADDRESSES[selectedChain1][token1];
    setSelectedTokenAddress(tokenAddress);
    setSelectedToken1(token1);
    setDepositeTokenAddress("");
    // DepositeFunds(tokenAddress, token1);
  };

  const DepositeFunds = async (tokenAddress, token1) => {
    if (CHAIN_TO_TOKEN_ADDRESSES?.BASE?.USDC === tokenAddress) {
      setDepositeTokenAddress(internalAccount);
      return;
    }
    setLoading(true);
    const payload = {
      walletAddress: internalAccount,
      sourceChain: selectedChain1?.toLowerCase(),
      sourceTokenAddress: tokenAddress,
      recipientAddress: internalAccount,
      refundWalletAddress: account,
      destinationChain: "base",
      destinationTokenAddress: CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC,
    };

    try {
      const { data } = await axios.post(
        "https://prod-api.aqua.cash/api/swap/swap-asset",
        payload,
        {
          headers: {
            "x-api-key": "AS-ufhjPLIAWE80wEBe4AOAgwI",
          },
        }
      );
      if (data) {
        handleCloseWarning();
        setShow5(true);
        const timer = setTimeout(() => {
          // console.log("2 minutes passed!");
          // setSelectedTokenAddress(null);
          setDepositeTokenAddress("");
          // setSelectedToken1(null);
        }, 2 * 60 * 1000);
        let key = "";
        if (data.message == "Swap request already exists") {
          setDepositeTokenAddress(data?.existingRequest?.assignedWalletAddress);
          key = data?.existingRequest?.listener_key;
        } else {
          setDepositeTokenAddress(data?.assignedWalletAddress);
          key = data?.listener_key;
        }
        const events = [
          {
            eventName: "connect",
            handler: () => console.log("Connected to the server"),
          },
          {
            eventName: key,
            handler: (data) => {
              console.log(data, "sokit deposite data");

              if (data?.status === AQUA_SWAP_TX_STATUS?.IN_SWAP) {
                console.log(data?.status);
                showToast("info", "Funds are in swap process please wait");
              }
              if (data?.status === AQUA_SWAP_TX_STATUS?.FINALIZED) {
                console.log(data?.status);
                showToast(
                  "info",
                  "Swap is finalized, completing the transaction. Please wait"
                );
              }
              if (data?.status === AQUA_SWAP_TX_STATUS?.REFUNDED) {
                console.log(data?.status);
                showToast(
                  "error",
                  "⚠️ Swap transaction failed. Funds refunded to your smart Account."
                );
              }
              if (data.status === AQUA_SWAP_TX_STATUS?.COMPLETED) {
                console.log(data?.status);
                showToast("success", "Funds received in your wallet");
                handleClose5();
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              }
            },
          },
        ];
        setSokitHit(events);
        setLoading(false);
      }
    } catch (error) {
      // console.error(error);
      setDepositeTokenAddress("");
      setLoading(false);
      showToast("error", "⚠️ Swap transaction failed.");
    }
  };
  useSocketEvents(sokitHit);
  return (
    <>
      {loading && <Loader text={loaderText} />}
      <Modal className="editmodal" show={show5} onHide={handleClose5} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {connected ? (
              <div className="maintitle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  cursor="pointer"
                  onClick={() => {
                    setConnected(false);
                  }}
                >
                  <path
                    d="M2.41453 8.60172L7.47703 3.53922C7.58258 3.43367 7.72573 3.37437 7.875 3.37437C8.02427 3.37437 8.16742 3.43367 8.27297 3.53922C8.37852 3.64477 8.43781 3.78792 8.43781 3.93719C8.43781 4.08645 8.37852 4.22961 8.27297 4.33515L4.17024 8.43719L15.1875 8.43719C15.3367 8.43719 15.4798 8.49645 15.5852 8.60194C15.6907 8.70743 15.75 8.8505 15.75 8.99969C15.75 9.14887 15.6907 9.29195 15.5852 9.39743C15.4798 9.50292 15.3367 9.56219 15.1875 9.56219L4.17024 9.56219L8.27297 13.6642C8.37852 13.7698 8.43781 13.9129 8.43781 14.0622C8.43781 14.2115 8.37852 14.3546 8.27297 14.4602C8.16742 14.5657 8.02427 14.625 7.875 14.625C7.72573 14.625 7.58258 14.5657 7.47703 14.4602L2.41453 9.39766C2.36223 9.34541 2.32074 9.28338 2.29244 9.21509C2.26413 9.1468 2.24956 9.07361 2.24956 8.99969C2.24956 8.92576 2.26413 8.85257 2.29244 8.78428C2.32074 8.716 2.36223 8.65396 2.41453 8.60172Z"
                    fill="white"
                  />
                </svg>
                <p className="titlepara">Via connected wallet</p>
              </div>
            ) : (
              <>
                {address ? (
                  <div className="maintitle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      cursor="pointer"
                      onClick={() => {
                        setAddress(false);
                      }}
                    >
                      <path
                        d="M2.41453 8.60172L7.47703 3.53922C7.58258 3.43367 7.72573 3.37437 7.875 3.37437C8.02427 3.37437 8.16742 3.43367 8.27297 3.53922C8.37852 3.64477 8.43781 3.78792 8.43781 3.93719C8.43781 4.08645 8.37852 4.22961 8.27297 4.33515L4.17024 8.43719L15.1875 8.43719C15.3367 8.43719 15.4798 8.49645 15.5852 8.60194C15.6907 8.70743 15.75 8.8505 15.75 8.99969C15.75 9.14887 15.6907 9.29195 15.5852 9.39743C15.4798 9.50292 15.3367 9.56219 15.1875 9.56219L4.17024 9.56219L8.27297 13.6642C8.37852 13.7698 8.43781 13.9129 8.43781 14.0622C8.43781 14.2115 8.37852 14.3546 8.27297 14.4602C8.16742 14.5657 8.02427 14.625 7.875 14.625C7.72573 14.625 7.58258 14.5657 7.47703 14.4602L2.41453 9.39766C2.36223 9.34541 2.32074 9.28338 2.29244 9.21509C2.26413 9.1468 2.24956 9.07361 2.24956 8.99969C2.24956 8.92576 2.26413 8.85257 2.29244 8.78428C2.32074 8.716 2.36223 8.65396 2.41453 8.60172Z"
                        fill="white"
                      />
                    </svg>
                    <p className="titlepara">Via deposit address</p>
                  </div>
                ) : (
                  "Deposit"
                )}
              </>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!connected && (
            <>
              {address ? (
                <>
                  <div className="mainparentinputssss">
                    <div className="left">
                      <p>Token</p>
                      <div class="dropdown dropdowntokenitems">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {selectedToken1 ? (
                            <div className="left-item">
                              <div className="maintokenimg">
                                <img
                                  src={TOKEN_IMAGES[selectedToken1]}
                                  alt={selectedToken1}
                                  className="tokenimg"
                                />
                                <img
                                  src={CHAIN_IMAGES[selectedChain1]}
                                  alt={selectedChain1}
                                  className="baseimg"
                                />
                              </div>
                              {selectedToken1}
                            </div>
                          ) : (
                            "Select Token"
                          )}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39743 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34541 15.6378 9.28338 15.6793 9.21509 15.7076C9.1468 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            {selectedChain1 &&
                              Object.keys(
                                CHAIN_TO_TOKEN_ADDRESSES[selectedChain1]
                              ).map((token1) => (
                                <li key={token1}>
                                  <a
                                    className="dropdown-item"
                                    onClick={() => handleTokenSelect1(token1)}
                                  >
                                    <div className="maintokenimg">
                                      <img
                                        src={TOKEN_IMAGES[token1]}
                                        alt={token1}
                                        className="tokenimg"
                                      />
                                    </div>
                                    {token1}
                                  </a>
                                </li>
                              ))}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="left">
                      <p>Chain</p>
                      <div class="dropdown dropdowntokenitems">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="left-item">
                            {selectedChain1 ? (
                              <>
                                <div className="maintokenimg">
                                  <img
                                    src={CHAIN_IMAGES[selectedChain1]}
                                    alt={selectedChain1}
                                    className="tokenimg"
                                  />
                                </div>
                                {selectedChain1}
                              </>
                            ) : (
                              "Select Chain"
                            )}
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39743 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34541 15.6378 9.28338 15.6793 9.21509 15.7076C9.1468 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            {Object.keys(CHAIN_TO_TOKEN_ADDRESSES).map(
                              (chain1) => (
                                <li>
                                  <a
                                    class="dropdown-item"
                                    key={chain1}
                                    onClick={() => handleChainSelect1(chain1)}
                                  >
                                    <div className="maintokenimg">
                                      <img
                                        src={CHAIN_IMAGES[chain1]}
                                        alt={chain1}
                                        className="tokenimg"
                                      />
                                    </div>
                                    {chain1}
                                  </a>
                                </li>
                              )
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="mainuppercontentss">
                    <QRCode
                      value={depositeTokenAddress}
                      size={200}
                      fgColor="black"
                    />
                  </div>

                  {/* {CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC !=
                    selectedTokenAddress && (
                    <>
                      <div className="mainnote">
                        <p className="notepara">
                          Note:Minimun{" "}
                          {depositeTokenAddress &&
                            CHAIN_TO_TOKEN_MIN_AMOUNT[selectedChain1][
                              selectedToken1
                            ]}{" "}
                          can be Deposit to this address; funds will appear in
                          your Wallet within seconds.
                        </p>
                      </div>
                    </>
                  )} */}
                  {CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC !=
                    selectedTokenAddress && (
                    <>
                      <div className="mainnote">
                        <p className="notepara">
                          ⚠️ This request applies to one swap only and will
                          remain valid for 2 minutes. For further swaps, please
                          initiate a new request. The minimum swap limit is{" "}
                          {
                            CHAIN_TO_TOKEN_MIN_AMOUNT[selectedChain1][
                              selectedToken1
                            ]
                          }{" "}
                        </p>
                      </div>
                    </>
                  )}
                  {depositeTokenAddress && (
                    <div className="depositboxmain">
                      <div className="depositleft">
                        <p className="address">Your deposit address:</p>
                        <input
                          type="text"
                          disabled
                          placeholder={depositeTokenAddress}
                        />
                      </div>
                      <CopyToClipboard
                        text={depositeTokenAddress}
                        onCopy={() => CallCopy()}
                      >
                        {copy ? (
                          <button className="copy">COPIED</button>
                        ) : (
                          <button className="copy">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M13.333 5.79517H6.66634C5.92996 5.79517 5.33301 6.39212 5.33301 7.1285V13.7952C5.33301 14.5315 5.92996 15.1285 6.66634 15.1285H13.333C14.0694 15.1285 14.6663 14.5315 14.6663 13.7952V7.1285C14.6663 6.39212 14.0694 5.79517 13.333 5.79517Z"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M2.66634 11.1285C1.93301 11.1285 1.33301 10.5285 1.33301 9.79517V3.1285C1.33301 2.39517 1.93301 1.79517 2.66634 1.79517H9.33301C10.0663 1.79517 10.6663 2.39517 10.6663 3.1285"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            COPY
                          </button>
                        )}
                      </CopyToClipboard>
                    </div>
                  )}
                  {!depositeTokenAddress && (
                    <button
                      className="commonbtn"
                      onClick={() => {
                        if (
                          CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC !=
                          selectedTokenAddress
                        ) {
                          handleClose5();
                          handleShowWarning();
                        } else {
                          DepositeFunds(selectedTokenAddress);
                        }
                      }}
                      disabled={!selectedToken1 ? true : false}
                    >
                      generate address
                    </button>
                  )}
                </>
              ) : (
                <div className="depositmainboxes">
                  <div
                    onClick={() => {
                      setConnected(true);
                    }}
                    className="depositinnerbox"
                  >
                    <div className="deposittexts">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                      >
                        <path
                          d="M26.9167 9.91667V5.66667C26.9167 5.29094 26.7674 4.93061 26.5017 4.66493C26.2361 4.39926 25.8757 4.25 25.5 4.25H7.08333C6.33189 4.25 5.61122 4.54851 5.07986 5.07986C4.54851 5.61122 4.25 6.33189 4.25 7.08333C4.25 7.83478 4.54851 8.55545 5.07986 9.0868C5.61122 9.61816 6.33189 9.91667 7.08333 9.91667H28.3333C28.7091 9.91667 29.0694 10.0659 29.3351 10.3316C29.6007 10.5973 29.75 10.9576 29.75 11.3333V17M29.75 17H25.5C24.7485 17 24.0279 17.2985 23.4965 17.8299C22.9652 18.3612 22.6667 19.0819 22.6667 19.8333C22.6667 20.5848 22.9652 21.3054 23.4965 21.8368C24.0279 22.3682 24.7485 22.6667 25.5 22.6667H29.75C30.1257 22.6667 30.4861 22.5174 30.7517 22.2517C31.0174 21.9861 31.1667 21.6257 31.1667 21.25V18.4167C31.1667 18.0409 31.0174 17.6806 30.7517 17.4149C30.4861 17.1493 30.1257 17 29.75 17Z"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4.25 7.08337V26.9167C4.25 27.6681 4.54851 28.3888 5.07986 28.9202C5.61122 29.4515 6.33189 29.75 7.08333 29.75H28.3333C28.7091 29.75 29.0694 29.6008 29.3351 29.3351C29.6007 29.0694 29.75 28.7091 29.75 28.3334V22.6667"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <h6 className="boxhead">Via connected wallet</h6>
                      <p className="boxpara">
                        {" "}
                        {internalAccount?.substring(0, 6)}...
                        {internalAccount?.substring(
                          internalAccount?.length - 6
                        )}
                      </p>
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      className="arrowimg"
                    >
                      <path
                        d="M15.5855 9.39828L10.523 14.4608C10.4174 14.5663 10.2743 14.6256 10.125 14.6256C9.97573 14.6256 9.83258 14.5663 9.72703 14.4608C9.62148 14.3552 9.56219 14.2121 9.56219 14.0628C9.56219 13.9135 9.62148 13.7704 9.72703 13.6648L13.8298 9.56281L2.8125 9.56281C2.66332 9.56281 2.52024 9.50355 2.41475 9.39806C2.30926 9.29257 2.25 9.1495 2.25 9.00031C2.25 8.85113 2.30926 8.70805 2.41475 8.60257C2.52024 8.49708 2.66332 8.43781 2.8125 8.43781L13.8298 8.43781L9.72703 4.33578C9.62148 4.23023 9.56219 4.08708 9.56219 3.93781C9.56219 3.78855 9.62148 3.64539 9.72703 3.53984C9.83258 3.4343 9.97573 3.375 10.125 3.375C10.2743 3.375 10.4174 3.4343 10.523 3.53984L15.5855 8.60234C15.6378 8.65458 15.6793 8.71662 15.7076 8.78491C15.7359 8.8532 15.7504 8.92639 15.7504 9.00031C15.7504 9.07423 15.7359 9.14743 15.7076 9.21572C15.6793 9.284 15.6378 9.34604 15.5855 9.39828Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    onClick={() => {
                      setAddress(true);
                    }}
                    className="depositinnerbox"
                  >
                    <div className="deposittexts">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                      >
                        <path
                          d="M25.4997 22.6667C25.4997 21.1019 24.2311 19.8334 22.6663 19.8334C21.1015 19.8334 19.833 21.1019 19.833 22.6667V25.5C19.833 27.0648 21.1015 28.3334 22.6663 28.3334C24.2311 28.3334 25.4997 27.0648 25.4997 25.5V22.6667Z"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.1667 8.49996C14.1667 6.93515 12.8981 5.66663 11.3333 5.66663C9.76853 5.66663 8.5 6.93515 8.5 8.49996V11.3333C8.5 12.8981 9.76853 14.1666 11.3333 14.1666C12.8981 14.1666 14.1667 12.8981 14.1667 11.3333V8.49996Z"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.5 28.3334H14.1667"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.5 19.8334H11.3333V28.3334"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M26.7148 5.86877L18.6191 13.9644"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.6191 5.86877L26.7148 13.9644"
                          stroke="#F24CA2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <h6 className="boxhead">Via deposit address</h6>
                      <p className="boxpara">No Limit - Instant</p>
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      className="arrowimg"
                    >
                      <path
                        d="M15.5855 9.39828L10.523 14.4608C10.4174 14.5663 10.2743 14.6256 10.125 14.6256C9.97573 14.6256 9.83258 14.5663 9.72703 14.4608C9.62148 14.3552 9.56219 14.2121 9.56219 14.0628C9.56219 13.9135 9.62148 13.7704 9.72703 13.6648L13.8298 9.56281L2.8125 9.56281C2.66332 9.56281 2.52024 9.50355 2.41475 9.39806C2.30926 9.29257 2.25 9.1495 2.25 9.00031C2.25 8.85113 2.30926 8.70805 2.41475 8.60257C2.52024 8.49708 2.66332 8.43781 2.8125 8.43781L13.8298 8.43781L9.72703 4.33578C9.62148 4.23023 9.56219 4.08708 9.56219 3.93781C9.56219 3.78855 9.62148 3.64539 9.72703 3.53984C9.83258 3.4343 9.97573 3.375 10.125 3.375C10.2743 3.375 10.4174 3.4343 10.523 3.53984L15.5855 8.60234C15.6378 8.65458 15.6793 8.71662 15.7076 8.78491C15.7359 8.8532 15.7504 8.92639 15.7504 9.00031C15.7504 9.07423 15.7359 9.14743 15.7076 9.21572C15.6793 9.284 15.6378 9.34604 15.5855 9.39828Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </>
          )}
          {connected && (
            <>
              <div className="mainparentinputssss">
                <div className="left">
                  <p>Token</p>
                  <div class="dropdown dropdowntokenitems">
                    <button
                      class="dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <div className="left-item">
                        <div className="maintokenimg">
                          <img
                            src={selectedImage}
                            alt="img"
                            className="tokenimg"
                          />
                          <img
                            src="/assets/playassets/base.svg"
                            alt="baseimg"
                            className="baseimg"
                          />
                        </div>
                        {selectedToken}
                      </div>
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39743 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34541 15.6378 9.28338 15.6793 9.21509 15.7076C9.1468 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z"
                          fill="white"
                        />
                      </svg> */}
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    ></ul>
                  </div>
                </div>
                <div className="left">
                  <p>Chain</p>
                  <div className="innermain">
                    <p className="walletpara">Base mainnet</p>
                    <img
                      src="\assets\playassets\base.svg"
                      alt="img"
                      className="img-fluid bsclogo"
                    />
                  </div>
                </div>
              </div>
              <div className="amountmain">
                <p className="innerpara">Amount</p>
                <p className="innerpara">
                  Balance:{" "}
                  <span className="whitetext">
                    {" "}
                    <>
                      {Number(userBalanceExternal)?.toLocaleString(undefined, {
                        minimumFractionDigits: 4,
                        maximumFractionDigits: 4,
                      })}
                    </>{" "}
                    {selectedToken}
                  </span>
                </p>
              </div>
              <div className="maininput">
                <input
                  type="number"
                  placeholder="0.00"
                  className="innerinput lasstinput"
                  value={depositeInput}
                  onChange={depositeHander}
                />
                <button className="maxbtn" onClick={maxHandler}>
                  max
                </button>
                <div className="maintokenimg">
                  <img
                    src={selectedImage}
                    alt="tokenimg"
                    className="tokenimg"
                  />
                  <img
                    src="/assets/playassets/base.svg"
                    alt="baseimg"
                    className="baseimg"
                  />
                </div>

                {errorBool && <p className="errorpara">{errorMessage}</p>}
                {/* <p className="errorpara">error</p> */}
              </div>

              <div className="bottom-btns">
                <button onClick={handleClose5} className="closebtn">
                  Close
                </button>
                <button
                  disabled={
                    !depositeInput || +depositeInput == 0 || errorBool
                      ? true
                      : false
                  }
                  onClick={depositeTransection}
                  className="depositbtn"
                >
                  Deposit
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal className="editmodal" show={show6} onHide={handleClose6} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="28"
                viewBox="0 0 38 28"
                fill="none"
              >
                <path
                  d="M36.3346 2L12.5013 25.8333L1.66797 15"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6>Deposit Completed!</h6>
          </div>
          <p className="mainparamodal">
            <span>
              {depositeInput} {selectedToken}
            </span>{" "}
            were successfully deposited to your account
          </p>

          <button
            onClick={() => {
              window.location.assign("/myprofile");
            }}
            className="back"
          >
            View History
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        className="editmodal"
        show={showWarning}
        onHide={handleCloseWarning}
        centered
      >
        <Modal.Body>
          <span className="infosvg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
            >
              <path
                d="M24.2676 34.1797C24.2676 34.6529 24.1273 35.1155 23.8644 35.5089C23.6015 35.9024 23.2278 36.2091 22.7906 36.3901C22.3534 36.5712 21.8723 36.6186 21.4082 36.5263C20.9441 36.434 20.5178 36.2061 20.1832 35.8715C19.8486 35.5369 19.6207 35.1106 19.5284 34.6465C19.4361 34.1823 19.4835 33.7013 19.6645 33.2641C19.8456 32.8269 20.1523 32.4532 20.5458 32.1903C20.9392 31.9274 21.4018 31.7871 21.875 31.7871C22.5096 31.7871 23.1181 32.0392 23.5668 32.4879C24.0155 32.9366 24.2676 33.5451 24.2676 34.1797ZM21.875 27.002C22.147 27.002 22.4078 26.8939 22.6001 26.7016C22.7924 26.5093 22.9004 26.2485 22.9004 25.9766V8.20312C22.9004 7.93117 22.7924 7.67036 22.6001 7.47806C22.4078 7.28577 22.147 7.17773 21.875 7.17773C21.6031 7.17773 21.3422 7.28577 21.1499 7.47806C20.9576 7.67036 20.8496 7.93117 20.8496 8.20312V25.9766C20.8496 26.2485 20.9576 26.5093 21.1499 26.7016C21.3422 26.8939 21.6031 27.002 21.875 27.002Z"
                fill="black"
              />
            </svg>
          </span>
          <h6 className="warninghead">Warning</h6>
          {CHAIN_TO_TOKEN_ADDRESSES.BASE.USDC != selectedTokenAddress && (
            <>
              <div className="mainnote">
                <p className="notepara">
                  ⚠️ This request applies to one swap only and will remain valid
                  for 2 minutes. For further swaps, please initiate a new
                  request. The minimum swap limit is{" "}
                  {CHAIN_TO_TOKEN_MIN_AMOUNT[selectedChain1][selectedToken1]}{" "}
                </p>
              </div>
            </>
          )}
          <button
            className="newokbtn"
            onClick={() => {
              DepositeFunds(selectedTokenAddress);
            }}
          >
            Okay
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DepositModel;
